var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height flex"},[_c('div',{staticClass:"sidebar-cont relative"},[_c('Sidebar')],1),_c('div',{staticClass:"dashboard-container flex1 p-2 flex fd-c fgap2"},[_c('Header'),_c('transition',{attrs:{"name":"pages","mode":"out-in"}},[_c('router-view')],1)],1),_c('cookies-policy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }